import ProjectRole, { ProjectMemberRoleType, ProjectMemberRoleJSON } from '@projectMembers/models/projectRole';

type GuestHashParams = {
	id: number;
	guestHash: string;
	roleType: ProjectMemberRoleType;
	enabled: boolean;
}

export type GuestHashJSON = {
	id: number;
	guest_hash: string;
	role: ProjectMemberRoleJSON;
	enabled: boolean;
}

export default class GuestHash {
	id: number;
	guestHash: string;
	roleType: ProjectMemberRoleType;
	enabled: boolean;

	constructor( { id, guestHash, roleType, enabled }: GuestHashParams ) {
		this.id = id;
		this.guestHash = guestHash;
		this.roleType = roleType;
		this.enabled = enabled || false;
	}

	static allFromJson( json: GuestHashJSON[] ) {
		return json.map( guestHashJson => this.fromJSON( guestHashJson ) );
	}

	get role() {
		return ProjectRole.fromID( this.roleType )!;
	}

	static fromJSON( json: GuestHashJSON ) {
		return new GuestHash( {
			id: json.id,
			guestHash: json.guest_hash,
			roleType: json.role.type,
			enabled: json.enabled
		} );
	}

	toJSON() {
		return {
			id: this.id,
			guest_hash: this.guestHash,
			role: {
				id: this.id,
				type: this.roleType
			},
			enabled: this.enabled
		};
	}
}
